<template>
<div>
	<div class="width-100 mdc-textfield mdc-textfield--upgraded">
		<input id="autocomplete" class="mdc-textfield__input" type="text" :value="value" :placeholder="placeholder" @input="setDefault($event.target.value)" ref="input" :class="{'input--focus' : value !== ''} " >
		<label for="autocomplete" class="mdc-textfield__label mdc-textfield__label--float-above">Start typing address</label>
		<a v-if="value !== ''" href="#" class="input__closebtn" @click.prevent="clear">X</a>
	</div>
	<span class="message--error" v-if="error">{{errorMessage}}</span>
</div>
</template>

<script>
export default {
	props: ['value', 'placeholder'],
	data: function() {
		return {
			autocomplete: {},
			error: false,
			errorMessage: '',
			isNotFullPostcode: false,
			address: {
				postcode: ''
			}
		}
	},
	mounted: function() {
		this.autocomplete = new google.maps.places.Autocomplete(
			(document.getElementById('autocomplete')),
			{
				types: ['geocode'],
				componentRestrictions: {country: 'gb'}
			});
		this.autocomplete.addListener('place_changed', this.googlePlacesUpdated);
	},
	watch: {
		address: {
			handler: function (newAddress) {
				 this.verifyPostcode();
			},
			deep: true
		}
	},
	methods: {
		googlePlacesUpdated: function() {
			var place = this.autocomplete.getPlace();

			var address = {
				buildingNumber: '',
				street: '',
				postcode: '',
				town: '',
            county: '',
				lat: 0,
				lng: 0
			};

			for (var i = 0; i < place.address_components.length; i++) {
				var address_type = place.address_components[i].types[0];


				if(address_type == 'street_number') {
					address.buildingNumber = place.address_components[i]['short_name'];
				}

				if(address_type == 'route') {
					address.street = place.address_components[i]['long_name'];
				}

				if(address.street == '') {
					address.street = place.address_components[i]['long_name'];
				}

				if(address_type == 'postal_code' || address_type == 'postal_code_prefix') {
					address.postcode = place.address_components[i]['short_name'];
				}

				if(address_type == 'postal_town') {
					address.town = place.address_components[i]['short_name'];
				}

                if(address_type == 'administrative_area_level_2') {
                    address.county = place.address_components[i]['long_name'];
                }
			}
			this.address.postcode = address.postcode;
			this.verifyPostcode();

			if(place.geometry) {
				address.lat = place.geometry.location.lat();
				address.lng = place.geometry.location.lng();
			}

			if(address.street == '' || address.postcode == '') {
				this.error = true;
				this.errorMessage = "Sorry, your keywords didn't match an address with at least a street and a postcode!";
			} else {
				this.error = false;
				this.errorMessage = '';
			}
			this.$emit('googlePlacesUpdated', address);
		},
		setDefault: function(value) {
		   this.$emit('setDefault', value);
		},
		clear: function() {
			console.log(this.$refs)
			this.$refs.input.value = '';
			this.$refs.input.focus();
		},
		verifyPostcode: function(){
			var filter = /^\s*\w{2,4}\s?\w{3}\s*$/;

			if(!filter.test(this.address.postcode)){
				 this.isNotFullPostcode = true;
			} else {
				this.isNotFullPostcode = false;
			}

			this.$emit('notFullPostcode', this.isNotFullPostcode);
		}

	}
}
</script>
